import * as metricFormatter from '@bingads-webui-campaign-legacy/performance-metric-formatter/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';

const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');

export const topChangesLegacyDeps = {
  metricFormatter,
  dateUtil,
  jsdata,
  legacyI18n,
};

